import { Suspense } from "react";
import OrgBootstrapWizard from "@/features/admin/org-bootstrap";

function WizardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="mb-5 h-10 w-72 rounded bg-line" />
      <div className="mb-6 h-16 rounded-lg bg-line" />
      <div className="h-[480px] rounded-lg bg-line" />
    </div>
  );
}

export default function AdminOrgPage() {
  return (
    <Suspense fallback={<WizardSkeleton />}>
      <OrgBootstrapWizard />
    </Suspense>
  );
}
